export const transformRequestEditItemsCustomsInfo = ({ storeId, resourceId, items }) => {
  return {
    storeId,
    resourceId,
    payload: {
      items,
    },
  }
}
